import React from "react";
import Signup from "../../components/Signup/Signup";
import RootModel from "../../models/RootModel/RootModel";
import SignupForm from "../../components/Signup/SignupForm";

export default function SignupFlowPage() {
  return (
    <div className="signup-flow-page" style={{direction: 'ltr'}}>
      <RootModel>
        {/* <Signup /> */}
        <SignupForm/>
      </RootModel>
    </div>
  );
}
